import PropTypes from 'prop-types';

import StockReturnCommandBar from './StockReturnCommandBar';
import StockReturnDetailSection from './StockReturnDetailSection';
import StockReturnMainInfoCard from './StockReturnMainInfoCard';

const StockReturnBlock = ({
  detail,
  defaultOpen = true,
  onRefetch,
  showActions = false,
}) => (
  <div className="receipt-card-elevate">
    <div className="receipt-card-surface">
      <StockReturnMainInfoCard
        detail={detail}
        embedded
        actions={
          showActions ? (
            <StockReturnCommandBar
              key={`${detail.id}-${detail.record?.updatedAt ?? ''}`}
              detail={detail}
              onRefetch={onRefetch}
            />
          ) : null
        }
      />
      <StockReturnDetailSection detail={detail} embedded defaultOpen={defaultOpen} />
    </div>
  </div>
);

StockReturnBlock.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    returnNo: PropTypes.string,
    status: PropTypes.string,
    record: PropTypes.shape({
      updatedAt: PropTypes.string,
    }),
    lines: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  defaultOpen: PropTypes.bool,
  onRefetch: PropTypes.func,
  showActions: PropTypes.bool,
};

export default StockReturnBlock;
